import styles from './components.module.css'

export default function ChanceToWin({
  chance,
}: {
  chance: string | undefined
}) {
  if (typeof chance === 'undefined') return <></>
  const chanceToWin = Number.isNaN(parseInt(chance)) ? 0 : chance
  return (
    <>
      <div className={styles['ctw-value']}>{chanceToWin}%</div>
      <div className={styles['ctw-outer']}>
        <div
          className={styles['ctw-inner']}
          style={{ width: `${chanceToWin}%` }}
        ></div>
      </div>
    </>
  )
}
